import { createListPlugin, createTodoListPlugin } from '@udecode/plate';
import { plateComponentUI } from '../config/plateComponentUI';
import { createMyPlugins } from '../config/typescript';

export const listPlugins = createMyPlugins([createListPlugin(), createTodoListPlugin()], {
  components: plateComponentUI,
});
